const AUTH_STORAGE_MATCHERS = [
  (key: string) => key.startsWith("sb-") && key.endsWith("-auth-token"),
  (key: string) => key.includes("supabase.auth"),
];

const clearMatchingStorageKeys = (storage: Storage) => {
  const keys: string[] = [];
  for (let index = 0; index < storage.length; index += 1) {
    const key = storage.key(index);
    if (key) keys.push(key);
  }

  keys
    .filter((key) => AUTH_STORAGE_MATCHERS.some((matches) => matches(key)))
    .forEach((key) => storage.removeItem(key));
};

/**
 * Removes only locally cached auth tokens. This avoids calling logout with a
 * stale refresh token, which can race with a fresh password sign-in and leave
 * the browser on /login even after a successful session is issued.
 */
export function clearStoredAuthSession() {
  if (typeof window === "undefined") return;

  try {
    clearMatchingStorageKeys(window.localStorage);
  } catch {
    // Ignore storage access errors.
  }

  try {
    clearMatchingStorageKeys(window.sessionStorage);
  } catch {
    // Ignore storage access errors.
  }
}
/** The two sign-in failures people can fix themselves; the login page shows a button for each */
export type SignInProblem = "unverified" | "wrong-password" | null;

export function signInProblem(message: string): SignInProblem {
  if (/email not confirmed/i.test(message)) return "unverified";
  if (/invalid login credentials/i.test(message)) return "wrong-password";
  return null;
}
